import {Product} from "./Product";
import {PriceService} from "./PriceService";

export interface ModelVisibility {
    name:string,
    visibility:boolean
}

export class Feature{
    protected name:string;
    protected imagePaths:any[];
    protected modelListON:ModelVisibility[] = [];
    protected modelListOFF:ModelVisibility[] = [];
    protected product:Product;
    protected hasAnimation:boolean;
    protected isPicked:boolean;

    constructor(name:string, product:Product, hasAnimation:boolean, imagePaths:any[], modelListON:string[], modelListOFF?:string[]){
        this.name = name;
        this.product = product;
        this.isPicked = false;
        modelListON.forEach((e)=>{
            this.modelListON.push({name:e, visibility:this.isPicked})
        })
        if(modelListOFF){
            modelListOFF.forEach((e)=>{
                this.modelListOFF.push({name:e, visibility:!this.isPicked})
            })
        }
    
        this.hasAnimation = hasAnimation;
        this.imagePaths = imagePaths;
    }

    public toogleModel(indicator?:string){
        this.isPicked = !this.isPicked;
        this.modelListON.forEach((model)=>{
            model.visibility = this.isPicked;
        })
        this.modelListOFF.forEach((model)=>{
            model.visibility = !this.isPicked;
        })
        PriceService.instance.calculatePrice();
    }

    public getModelList(){
        let allModel: ModelVisibility[] = [];
        allModel = allModel.concat(allModel, this.modelListON);
        allModel = allModel.concat(allModel, this.modelListOFF);
        return allModel;
    }

    public getName(){
        return this.name;
    }

    public getProduct():Product{
        if(!this.isPicked){
            return null;
        }
        return this.product;
    }

    public getImagePath():any{
        if(this.isPicked){
            return this.imagePaths[1];
        }
        else{
            return this.imagePaths[0];
        }
    }

    public getProductForAddingPrice():Product[]{
        return [this.product];
    }

    public getHasAnim(){
        return this.hasAnimation;
    }
}